export default __webpack_public_path__ + "54588cc.png";